/**
 * @generated SignedSource<<ac36cae82c964e178883f9c94c1925cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type IssuePickerIssue$data = {
  readonly closed: boolean;
  readonly id: string;
  readonly state: IssueState;
  readonly title: string;
  readonly " $fragmentType": "IssuePickerIssue";
};
export type IssuePickerIssue$key = {
  readonly " $data"?: IssuePickerIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssuePickerIssue">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssuePickerIssue"
};

(node as any).hash = "b2679d490b8954d1331fb6837fc9780d";

export default node;
